module.exports = function(
    addressCoords,
    clusterColor,
    iconImageSize,
    clusterImage = ''
) {
    return {
        run() {
            let yMapLoader = require ('ymaps-loader');
            let clusterImageHrefNotActive;
            let clusterImageHrefActive;

            yMapLoader({ apiKey: yMapApiKey}).then(() => {
                ymaps.ready(function () {
                    let coordsLat = $('#city_contacts').data('lat');
                    let coordsLon = $('#city_contacts').data('lon');

                    if($('.contacts-wrapper').length) {
                        let coordsLat = $('#city_contacts').data('lat');
                        let coordsLon = $('#city_contacts').data('lon');
                        let coordsMap = new ymaps.Map('map', {
                                // Немного сместим центр карты
                                center: [+coordsLat, coordsLon - 0.008],
                                zoom: 15,
                                controls: ['zoomControl']
                            }, {
                                searchControlProvider: 'yandex#search'
                        });
        
                        let placemark = new ymaps.Placemark([+coordsLat, +coordsLon], {
                            //
                        }, {
                            iconLayout: 'default#image',
                            iconImageHref: addressCoords,
                            iconImageSize: [30, 30]
                        });
        
                        coordsMap.controls.remove('searchControl');
                    
                        // Добавляем координаты офиса на карту
                        coordsMap.geoObjects.add(placemark);
                    }
        
                    // Карта экспертиз
                    if($('#cases-map').length) {
                        if(domain == 'computer') {
                            coordsLat = $('#city_contacts').data('lat_moscow');
                            coordsLon = $('#city_contacts').data('lon_moscow');
                        }

                        let casesMap = new ymaps.Map('cases-map', {
                            center: [+coordsLat, +coordsLon],
                            zoom: 4,
                            controls: ['zoomControl']
                            }, {
                            searchControlProvider: 'yandex#search'
                        });
        
                        // Кластер
                        let GeoObjects = [];
                        let flameCoords = $('#flame_coords').data('arr');
                        for (const [index,coord] of flameCoords.entries()) {
                            if (domain == 'main' || domain == 'dashboard') {
                                for (let filter of Object.values(examinationsKindFilter)) {
                                    if (filter['alias'] == coord.examination_kind) {
                                        clusterImageHrefNotActive = `/images/icons/${coord.examination_kind}.png`;
                                        continue;
                                    }
                                }
                            } else {
                                clusterImageHrefNotActive = clusterImage;
                            }

                            GeoObjects[index] = new ymaps.GeoObject({
                                geometry: {type: "Point", coordinates: [coord.lat, coord.lon]}
                            },{
                                iconLayout: 'default#image',
                                iconImageHref: clusterImageHrefNotActive,
                                iconImageSize: iconImageSize
                            });
                            GeoObjects[index].name = coord.examination_id;
                            GeoObjects[index].examination_kind = coord.examination_kind;
                        };

                        let clusterer = new ymaps.Clusterer({
                            clusterIconColor: clusterColor,
                            gridSize: 64,
                            groupByCoordinates: false,
                            hasBalloon: false,
                            hasHint: false,
                            margin: 10,
                            maxZoom: 10,
                            minClusterSize: 2,
                            showInAlphabeticalOrder: false,
                            viewportMargin: 128,
                            zoomMargin: 0,
                            clusterDisableClickZoom: true
                        });
                        clusterer.add(GeoObjects);
                        
                        // Удалим координаты из DOM
                        new Promise((resolve) => {
                            casesMap.geoObjects.add(clusterer);
                            resolve(true);
                        }).then(() => {
                            $('#flame_coords').remove();
                        });

                        casesMap.behaviors.disable('scrollZoom');

                        // Кликнул ли пользователь  по объекту на карте
                        let userGeoObjectClick = false;
        
                        function loadExpertise(examination_id) {
                            axios.post('/multi_site/examination_by_coords', {
                                examination_id: examination_id
                            })
                            .then(function(response) {
                                $('.case-info-wrapper').html(response.data);
                                $('.case-info-wrapper').show(200);
                            });
                        }

                        // Перемешивание элементов кластера
                        function shuffle(arr) {
                            return arr.sort(() => Math.round(Math.random() * 100) - 50);
                        }

                        let allClusterItems = shuffle(clusterer.getGeoObjects());

                        // Получение случайной экспертизы по нужному виду
                        function getRandomPreferredExamination() {
                            let index = Math.floor(Math.random() * allClusterItems.length);
                            if(domain != 'main') {
                                // Для лендингов нужны экспертизы нужного вида
                                if(allClusterItems[index]['examination_kind'] != preferredExaminationKind) return getRandomPreferredExamination();
                            }
                            
                            return allClusterItems[index];
                        }

                        // Подгрузим экспертизу после загрузки страницы
                        if ($('#mobile-state').is(':hidden') && !userGeoObjectClick) {
                            loadExpertise(getRandomPreferredExamination()['name']);
                        }

                        // Отображение случайной экспертизы на карте каждые n секунд
                        setInterval(() => {
                            if ($('#mobile-state').is(':hidden') && !userGeoObjectClick) {
                                loadExpertise(getRandomPreferredExamination()['name']);
                            }
                        },7000);
                        
                        // Отслеживаем событие
                        let oldClusterItem;
                        casesMap.geoObjects.events.add('click', function (event) {
                            userGeoObjectClick = true;
        
                            // for (let object of GeoObjects) {
                            //     object.options.set('iconImageHref', clusterImageHrefNotActive);
                            // }
        
                            // event.get('target').options.set('iconImageHref', clusterImageHrefActive);
        
                            if (event.get('target').name) {
                                let url;
                                if(domain == 'dashboard') {
                                    if(dashboard_page == 'experts_list') {
                                        url = '/multi_site/experts_by_coords';
                                    } else {
                                        url = '/multi_site/examination_by_coords_planfix';
                                    }
                                } else {
                                    url = '/multi_site/examination_by_coords';
                                }

                                axios.post(url, {
                                    examination_id: event.get('target').name
                                })
                                .then(function(response) {
                                    $('.case-info-wrapper').hide(200);
                                    setTimeout(function() {
                                        $('.case-info-wrapper').html(response.data);
                                        $('.case-info-wrapper').show(200);
                                    },200);
                                });
                            }
                            else {
                                let firstClusterItem = event.get('target')['properties']['_data']['geoObjects'][0]['name']
                                let zoomCoords = event.get('target').geometry._coordinates;
        
                                casesMap.setCenter([zoomCoords[0], zoomCoords[1]], casesMap.getZoom() + 4);
                                    
                                if (oldClusterItem != firstClusterItem) {
                                    if ($('#mobile-state').is(':hidden')) {
                                        axios.post('/multi_site/examination_by_coords', {
                                            examination_id: firstClusterItem
                                        })
                                        .then(function(response) {
                                            $('.case-info-wrapper').hide(200);
                                            setTimeout(function() {
                                                $('.case-info-wrapper').html(response.data);
                                                $('.case-info-wrapper').show(200);
                                            },200);
                                        });
                                    } 
                                }
                                oldClusterItem = firstClusterItem;
                            }
                        });
                    }
                });
            });
        }
    }
}
